(() => {
  const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const init = (section) => {
    const track = section.querySelector('[data-mb40-track]');
    const previous = section.querySelector('[data-mb40-prev]');
    const next = section.querySelector('[data-mb40-next]');
    if (!track || !previous) return;

    const update = () => {
      const end = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= end - 2;
    };

    const move = (direction) => {
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  document.querySelectorAll('.section-matchboox-home .mb40').forEach(init);

  document.querySelectorAll('[data-mb40-featured]').forEach((carousel) => {
    const track = carousel.querySelector('[data-mb40-featured-track]');
    const slides = [...carousel.querySelectorAll('[data-mb40-featured-slide]')];
    const dots = [...carousel.querySelectorAll('[data-mb40-featured-dot]')];
    const previous = carousel.querySelector('[data-mb40-featured-prev]');
    const next = carousel.querySelector('[data-mb40-featured-next]');
    let index = 0;
    let switchToken = 0;

    const featuredTitle = (title, author) => {
      const prefix = String(author || '').trim();
      if (!prefix) return String(title || '').trim();
      return String(title || '').replace(new RegExp(`^${escapeRegExp(prefix)}\\s*[–—-]\\s*`, 'i'), '').trim();
    };

    const storyOnly = (html, title) => {
      const textHost = document.createElement('div');
      textHost.innerHTML = html || '';
      textHost.querySelectorAll('style, script').forEach((node) => node.remove());
      const boilerplate = /(luciferdoos|geschenkdoos|harmonicaboek|harmonica-?boek|miniatuurboek|uitvouwbare|leporello|\bpagina['’]?s?\b|handgemaakt|zelfstandige\s+(?:MatchBoox[- ]?)?uitgave|losse uitgave|afzonderlijke uitgave|los verkrijgbaar|complete reeks|onderdeel van|\bserie\b|kattenpo[eë]zie|oorlogspo[eë]zie|liefde en relaties|literatuur en kunst|Nederlandse muziek|voetbal en levenswijsheid|illustraties?|beelden?|tekeningen?|linosneden|vormgeving|fotografie|kenmerken)/i;
      const titlePattern = title ? new RegExp(`^${escapeRegExp(title)}\\s*[·:–—-]*\\s*$`, 'i') : null;
      const textParts = [...textHost.querySelectorAll('p, li')]
        .map((node) => node.textContent.replace(/\s+/g, ' ').trim())
        .filter(Boolean);
      const sentences = (textParts.length ? textParts : [textHost.textContent])
        .flatMap((part) => part.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || []);
      const story = sentences
        .map((sentence) => sentence.trim())
        .filter((sentence) => sentence
          && sentence.length > 35
          && !(titlePattern && titlePattern.test(sentence))
          && !boilerplate.test(sentence))
        .map((sentence) => sentence
          .replace(/\b(?:dit|het)\s+(?:handgemaakte\s+)?MatchBoox(?:-miniatuurboek)?\b/gi, 'Dit verhaal')
          .replace(/\been\s+handgemaakt\s+miniatuurboek\s+over\b/i, 'Een verhaal over'))
        .map((sentence) => /[.!?…]["')\]]?$/.test(sentence) ? sentence : `${sentence}.`);
      const words = story.join(' ').split(/\s+/).filter(Boolean);
      return words.slice(0, 110).join(' ');
    };

    const hydrate = async (slide) => {
      const handle = slide?.dataset.mb40FeaturedHandle;
      if (!handle) return;
      if (slide._mb40HydratePromise) return slide._mb40HydratePromise;
      if (slide.dataset.mb40FeaturedLoaded === 'true') return;
      slide.dataset.mb40FeaturedLoaded = 'true';
      slide._mb40HydratePromise = (async () => { try {
        const product = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' }).then((response) => {
          if (!response.ok) throw new Error('Product niet gevonden');
          return response.json();
        });
        const title = slide.querySelector('.mb40__featured-copy h2');
        const description = slide.querySelector('[data-mb40-featured-description]');
        const link = slide.querySelector('.mb40__featured-image');
        const productLink = slide.querySelector('[data-mb40-featured-link]');
        const image = slide.querySelector('.mb40__featured-image img');
        const liveImage = product.images?.[0]?.src || product.images?.[0];
        if (liveImage) {
          await new Promise((resolve) => {
            const preload = new Image();
            preload.onload = resolve;
            preload.onerror = resolve;
            preload.src = liveImage;
            if (preload.complete) resolve();
          });
        }
        if (title && product.title) title.textContent = featuredTitle(product.title, slide.dataset.mb40FeaturedAuthor);
        if (link && product.handle) link.href = `/products/${product.handle}`;
        if (productLink && product.handle) productLink.href = `/products/${product.handle}`;
        if (image && liveImage) image.src = liveImage;
        if (description && product.description) {
          const story = storyOnly(product.description, product.title || title?.textContent);
          description.textContent = story;
          description.hidden = !story;
        }
      } catch (_error) { /* Behoud de gecontroleerde fallback. */ }
      })();
      return slide._mb40HydratePromise;
    };

    const show = async (newIndex) => {
      const targetIndex = (newIndex + slides.length) % slides.length;
      const token = ++switchToken;
      const current = slides[index];
      const target = slides[targetIndex];
      await hydrate(target);
      if (token !== switchToken) return;
      if (target !== current && track) {
        track.style.height = `${track.offsetHeight}px`;
        target.hidden = false;
        target.classList.add('is-preparing');
        requestAnimationFrame(() => requestAnimationFrame(() => {
          current?.classList.remove('is-active');
          target.classList.remove('is-preparing');
          target.classList.add('is-active');
          track.style.height = `${target.scrollHeight}px`;
          window.setTimeout(() => {
            slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== targetIndex; });
            track.style.height = '';
          }, 360);
        }));
      }
      index = targetIndex;
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      window.setTimeout(() => {
        hydrate(slides[(index + 1) % slides.length]);
        hydrate(slides[(index - 1 + slides.length) % slides.length]);
      }, 100);
    };

    previous?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
    show(0);
  });
})();

/* De hero-video opent en start alleen na een klik op de playknop. */
(() => {
  const boot = (scope = document) => {
    scope.querySelectorAll?.('.section-matchboox-home').forEach((section) => {
      if (section.dataset.mbHeroVideoReady === 'true') return;
      const open = section.querySelector('[data-mb40-video-open]');
      const modal = section.querySelector('[data-mb40-video-modal]');
      const dialog = modal?.querySelector('.mb40__video-dialog');
      const videos = [...(modal?.querySelectorAll('video') || [])];
      if (!open || !modal || !dialog || !videos.length) return;
      section.dataset.mbHeroVideoReady = 'true';
      let scrollY = 0;
      let previousBodyStyle = '';

      const activeVideo = () => videos.find((video) => window.getComputedStyle(video).display !== 'none') || videos[0];

      const alignPlayTrigger = () => {
        const actions = section.querySelector('.mb40__hero-actions');
        const visual = section.querySelector('.mb40__hero-visual');
        if (!actions || !visual) {
          open.style.removeProperty('top');
          open.style.removeProperty('bottom');
          open.style.removeProperty('left');
          open.style.removeProperty('transform');
          return;
        }
        if (window.innerWidth < 990) {
          const image = visual.querySelector('.mb40__hero-image img');
          const visualRect = visual.getBoundingClientRect();
          const imageRect = image?.getBoundingClientRect() || visualRect;
          const mobileInset = 21.56;
          /* Meet vanaf de zichtbare afbeeldingsrand. Daardoor is de witte ruimte
             links exact gelijk aan de ruimte onder de volledige playknop. */
          const imageInsetLeft = Math.max(0, imageRect.left - visualRect.left);
          open.style.top = 'auto';
          open.style.right = 'auto';
          open.style.bottom = `${mobileInset}px`;
          open.style.left = `${imageInsetLeft + mobileInset}px`;
          open.style.transform = 'none';
          return;
        }
        const actionsRect = actions.getBoundingClientRect();
        const visualRect = visual.getBoundingClientRect();
        const buttonHalf = open.getBoundingClientRect().height / 2;
        const desiredCenter = actionsRect.top + (actionsRect.height / 2) - visualRect.top;
        const safeCenter = Math.max(buttonHalf + 14, Math.min(visualRect.height - buttonHalf - 14, desiredCenter));
        const buttonWidth = open.getBoundingClientRect().width;
        const equalInset = Math.max(14, visualRect.height - safeCenter - buttonHalf);
        open.style.top = `${safeCenter}px`;
        open.style.left = `${Math.min(visualRect.width - buttonWidth - 14, equalInset)}px`;
        open.style.bottom = 'auto';
        open.style.transform = 'translateY(-50%)';
      };

      const positionDialog = () => {
        if (window.innerWidth < 750) {
          const image = section.querySelector('.mb40__hero-image img');
          const imageRect = image?.getBoundingClientRect();
          if (imageRect) {
            dialog.style.top = `${imageRect.top}px`;
            dialog.style.left = `${imageRect.left}px`;
            dialog.style.width = `${imageRect.width}px`;
            dialog.style.height = `${imageRect.height}px`;
            dialog.style.transform = 'none';
            return;
          }
        }
        dialog.style.removeProperty('height');
        dialog.style.removeProperty('transform');
        const eyebrow = section.querySelector('.mb40__eyebrow');
        const actions = section.querySelector('.mb40__hero-actions');
        const playRect = open.getBoundingClientRect();
        const upperEdge = eyebrow?.getBoundingClientRect().bottom ?? 0;
        const lowerEdge = actions?.getBoundingClientRect().top ?? window.innerHeight;
        const dialogHeight = dialog.getBoundingClientRect().height;
        const halfHeight = dialogHeight / 2;
        const desktopCenter = lowerEdge > upperEdge ? (upperEdge + lowerEdge) / 2 : window.innerHeight / 2;
        const desiredCenter = window.innerWidth < 990
          ? playRect.top + (playRect.height / 2)
          : desktopCenter;
        const safeCenter = Math.max(halfHeight + 12, Math.min(window.innerHeight - halfHeight - 12, desiredCenter));
        modal.style.setProperty('--mb40-video-center-y', `${safeCenter}px`);
      };

      const close = () => {
        videos.forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        open.style.removeProperty('visibility');
        document.body.style.cssText = previousBodyStyle;
        window.scrollTo(0, scrollY);
        open.focus({ preventScroll: true });
      };
      const show = () => {
        scrollY = window.scrollY;
        previousBodyStyle = document.body.style.cssText;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        positionDialog();
        if (window.innerWidth < 990) open.style.visibility = 'hidden';
        modal.querySelector('[data-mb40-video-close]')?.focus({ preventScroll: true });
        activeVideo().play().catch(() => {});
      };

      open.addEventListener('click', show);
      modal.querySelectorAll('[data-mb40-video-close]').forEach((button) => button.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) close();
      });
      window.addEventListener('resize', () => {
        alignPlayTrigger();
        if (!modal.hidden) positionDialog();
      });
      videos.forEach((video) => video.addEventListener('loadedmetadata', () => {
        if (!modal.hidden) positionDialog();
      }));
      section.querySelector('.mb40__hero-image img')?.addEventListener('load', alignPlayTrigger);
      requestAnimationFrame(alignPlayTrigger);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

(() => {
  const escapeText = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);
  const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const displayTitle = (title, creators) => {
    let result = String(title || '').trim();
    String(creators || '').split(',').map((creator) => creator.trim()).filter(Boolean).forEach((creator) => {
      result = result.replace(new RegExp(`^${escapeRegExp(creator)}\\s+(?:illustraties?|beelden?|kunst|tekeningen?|aquarellen?|portretten?|schilderijen?|vormgeving|typografie)\\s*[–—-]\\s*`, 'i'), '').trim();
      result = result.replace(new RegExp(`^${escapeRegExp(creator)}\\s*[–—-]\\s*`, 'i'), '').trim();
    });
    return result;
  };


  /* Toont bij een zoekopdracht op een maker alleen diens eigen editie en niet
     ook nog de auteursversie met hetzelfde MB-nummer ernaast. */
  const mbSkuInfoCache = new Map();
  const mbSkuInfo = (handle) => {
    if (!mbSkuInfoCache.has(handle)) {
      mbSkuInfoCache.set(handle, fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          const sku = String(product?.variants?.[0]?.sku || '').trim();
          const match = sku.match(/^MB\s*(\d+)(?:\s*([A-Z]+))?$/i);
          return match ? { number: Number(match[1]), letter: (match[2] || '').toUpperCase(), series: /serie/i.test(String(product?.type || '')) } : { number: -1, letter: '', series: /serie/i.test(String(product?.type || '')) };
        })
        .catch(() => null));
    }
    return mbSkuInfoCache.get(handle);
  };
  const mbDropAuthorDuplicates = async (items) => {
    const infos = await Promise.all(items.map((item) => (item?.handle ? mbSkuInfo(item.handle) : Promise.resolve(null))));
    const editionNumbers = new Set(infos.filter((info) => info && info.letter).map((info) => info.number));
    const seen = new Set();
    const kept = [];
    items.forEach((item, index) => {
      const info = infos[index];
      if (info && info.number !== -1 && !info.letter && editionNumbers.has(info.number)) return;
      if (!item?.handle || seen.has(item.handle)) return;
      seen.add(item.handle);
      kept.push({ item, info: info || { number: -1, letter: '', series: false }, index });
    });
    /* Hoogste MB-nummer eerst, daarna aflopend. */
    const mbMap = {};
    try { JSON.parse(document.getElementById('mb-series-map-data').textContent).split(';').forEach(function (entry) { var p = entry.trim().split('>'); if (p.length > 1) { var g = p[0].trim(); mbMap[g] = { g: g, pos: 0 }; p[1].split(',').forEach(function (k, i) { mbMap[k.trim()] = { g: g, pos: i + 1 }; }); } }); } catch (err) {}
    const gmax = {};
    kept.forEach(function (en) { var m = mbMap[en.item.handle]; en.g = m ? m.g : en.item.handle; en.pos = m ? m.pos : 0; en.mapped = !!m; });
    if (kept.some(function (en) { return !en.mapped && en.info.letter; })) {
      const mapHandles = Object.keys(mbMap);
      const mapInfos = await Promise.all(mapHandles.map(function (h) { return mbSkuInfo(h); }));
      const numToPos = {};
      mapHandles.forEach(function (h, i) { const inf = mapInfos[i]; if (inf && inf.number !== -1 && !inf.letter && numToPos[inf.number] === undefined) numToPos[inf.number] = mbMap[h]; });
      kept.forEach(function (en) { if (!en.mapped && en.info.letter && numToPos[en.info.number]) { en.g = numToPos[en.info.number].g; en.pos = numToPos[en.info.number].pos; } });
    }
    kept.forEach(function (en) { gmax[en.g] = Math.max(gmax[en.g] === undefined ? -1 : gmax[en.g], en.info.number); });
    /* Serie eerst, dan de boekjes in de volgorde van de seriekaart; groepen op hoogste MB-nummer. */
    kept.sort((left, right) => (gmax[right.g] - gmax[left.g])
      || (left.g < right.g ? -1 : (left.g > right.g ? 1 : 0))
      || (left.pos - right.pos)
      || (right.info.number - left.info.number)
      || left.info.letter.localeCompare(right.info.letter)
      || (left.index - right.index));
    return kept.map((entry) => entry.item);
  };
  const initLiveSearch = (form) => {
    if (form.dataset.mbLiveSearchReady === 'true') return;
    const input = form.querySelector('[data-mb40-search-input]');
    const results = (form.closest('.mb-site-header--unified') || form.parentElement).querySelector('[data-mb40-live-results]');
    if (!input || !results) return;
    let timer;
    const dataSource = document.querySelector('script[id^="MatchBooxCarouselData-"]');
    const fondsSource = document.querySelector('[data-mb-fonds-authors]');
    const groupsSource = document.querySelector('[data-mb-discovery-groups]');
    if (!dataSource || !fondsSource || !groupsSource) return;
    form.dataset.mbLiveSearchReady = 'true';
    let data;
    let fonds;
    let groups;
    try {
      data = JSON.parse(dataSource.textContent);
      fonds = JSON.parse(fondsSource.textContent);
      groups = JSON.parse(groupsSource.textContent);
    } catch (_error) { return; }
    const additions = document.querySelector('[data-mb-fonds-author-additions]');
    if (additions) {
      try { Object.entries(JSON.parse(additions.textContent)).forEach(([name, handles]) => { fonds[name] = [...new Set([...(fonds[name] || []), ...handles])]; }); } catch (_error) { /* Behoud fonds. */ }
    }
    const catalog = new Map();
    [...(data.large || []), ...(data.categories || []).flatMap((group) => group.items || [])].forEach((item) => {
      if (item?.handle && !catalog.has(item.handle)) catalog.set(item.handle, item);
    });
    const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const compact = (value) => normalize(value).replace(/[^a-z0-9]+/g, '');
    const matchesCreatorName = (name, query) => {
      const normalizedName = normalize(name);
      const normalizedQuery = normalize(query);
      const compactQuery = compact(query);
      return normalizedName.includes(normalizedQuery) || (compactQuery.length >= 2 && compact(name).includes(compactQuery));
    };
    const authorsFor = (handle) => Object.entries(fonds).filter(([, handles]) => handles.includes(handle)).map(([name]) => name);
    const visualSignature = (item) => (Math.max(1, Math.ceil(String(item.title || '').length / 29)) * 100) + Math.max(1, Math.ceil(authorsFor(item.handle).join(', ').length / 34));
    const sortVisual = (items) => [...items].sort((a, b) => visualSignature(a) - visualSignature(b) || String(a.title).localeCompare(String(b.title), 'nl'));
    const arrangeSeries = (items) => {
      const groups = Object.assign({}, window.MatchBooxSeriesGroups || {}, (function () { const g = {}; try { JSON.parse(document.getElementById('mb-series-map-data').textContent).split(';').forEach(function (e) { const p = e.trim().split('>'); if (p.length > 1) g[p[0].trim()] = p[1].split(',').map(function (x) { return x.trim(); }); }); } catch (err) {} return g; })());
      const used = new Set();
      const output = [];
      const seriesHandles = [];
      const memberToSeries = new Map();
      Object.entries(groups).forEach(([seriesHandle, handles]) => handles.forEach((handle) => memberToSeries.set(handle, seriesHandle)));
      items.forEach((item) => {
        const seriesHandle = groups[item.handle] ? item.handle : Object.keys(groups).find((handle) => groups[handle].includes(item.handle));
        if (seriesHandle && !seriesHandles.includes(seriesHandle)) seriesHandles.push(seriesHandle);
      });
      sortVisual(items.filter((item) => !groups[item.handle] && !memberToSeries.has(item.handle)))
        .forEach((item) => { output.push(item); used.add(item.handle); });
      seriesHandles.forEach((seriesHandle) => [seriesHandle, ...(groups[seriesHandle] || [])].forEach((handle) => {
        const product = catalog.get(handle);
        if (product && !used.has(handle)) { output.push(product); used.add(handle); }
      }));
      sortVisual(items.filter((item) => !used.has(item.handle)))
        .forEach((item) => { output.push(item); used.add(item.handle); });
      return output;
    };
    const subjectTitle = (value) => normalize(String(value || '')
      .replace(/^.*?\s*[–—]\s*/, '')
      .replace(/\s*\([^)]*\)\s*$/g, '')
      .replace(/[^a-z0-9]+/gi, ''));
    const sameSubject = (left, right) => left === right || left.startsWith(right) || right.startsWith(left);
    const addIllustratorSeries = (products, illustrator) => {
      const seriesGroups = window.MatchBooxSeriesGroups || {};
      const subjects = products.map((item) => subjectTitle(item.title)).filter(Boolean);
      const output = [...products];
      Object.entries(seriesGroups).forEach(([seriesHandle, members]) => {
        if (members.length < 4) return;
        const complete = members.every((handle) => {
          const memberSubject = subjectTitle(catalog.get(handle)?.title);
          return memberSubject && subjects.some((subject) => sameSubject(subject, memberSubject));
        });
        const series = catalog.get(seriesHandle);
        if (complete && series && !output.some((item) => item.handle === seriesHandle)) {
          output.unshift({ ...series, _mbCreator: illustrator, _mbIllustratorVersion: false });
        }
      });
      return output;
    };
    const addExclusiveAuthorSeries = (products, author) => {
      const directHandles = new Set(products.map((product) => product.handle));
      const output = [...products];
      Object.entries(window.MatchBooxSeriesGroups || {}).forEach(([seriesHandle, members]) => {
        if (!members.length || !members.every((handle) => directHandles.has(handle))) return;
        const series = catalog.get(seriesHandle);
        if (series && !directHandles.has(seriesHandle)) {
          output.unshift({ ...series, _mbCreator: author, _mbIllustratorVersion: false });
          directHandles.add(seriesHandle);
        }
      });
      return output;
    };

    const render = (products, query) => {
      if (!products.length) {
        results.innerHTML = `<p class="mb40__search-status">Geen resultaten gevonden voor “${escapeText(query)}”.</p>`;
        results.hidden = false;
        return;
      }
      const cards = products.map((product) => {
        const authors = product._mbCreator
          || authorsFor(product.handle).join(', ')
          || (product.kind !== 'series' && product.caption !== product.title ? product.caption : '');
        return `<a class="mb-discovery__card" href="${escapeText(product.url)}" data-mb-header-product="${escapeText(product.url)}" data-mb-header-creators="${escapeText(authors)}" data-mb-wants-illustrator="${product._mbIllustratorVersion === true ? 'true' : 'false'}" data-mb-skip-version-filter="${product._mbSkipVersionFilter === true ? 'true' : 'false'}">
          <span class="mb-discovery__cover"><img alt="Omslag van ${escapeText(product.title)}" loading="eager"></span>
          <strong hidden></strong><span>${escapeText(authors || '\u00a0')}</span>
        </a>`;
      }).join('');
      results.innerHTML = `<div class="mb40__uniform-search"><div class="mb40__uniform-track">${cards}</div><button type="button" class="mb40__uniform-prev" aria-label="Vorige resultaten">&lt;</button><button type="button" class="mb40__uniform-next" aria-label="Meer resultaten">&gt;</button></div>`;
      results.hidden = false;
      const track = results.querySelector('.mb40__uniform-track');
      const previous = results.querySelector('.mb40__uniform-prev');
      const next = results.querySelector('.mb40__uniform-next');
      const update = () => {
        const noOverflow = track.scrollWidth <= track.clientWidth + 2;
        previous.hidden = noOverflow || track.scrollLeft <= 2;
        next.hidden = noOverflow || track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      requestAnimationFrame(update);
      results.querySelectorAll('[data-mb-header-product]').forEach(async (card) => {
        try {
          const product = await fetch(`${card.dataset.mbHeaderProduct}.js`, { credentials: 'same-origin' }).then((response) => response.json());
          const isIllustratorVersion = (product.variants || []).some((variant) => /\s[BDEFHKL]$/i.test(String(variant?.sku || '').trim())) || [].concat(product.tags || []).some((tag) => /^(Illustrator|Vormgever|Alternatieve)-editie$/.test(String(tag).trim()));
          if (card.dataset.mbSkipVersionFilter !== 'true' && isIllustratorVersion !== (card.dataset.mbWantsIllustrator === 'true')) {
            card.remove();
            return;
          }
          const image = product.images?.[0]?.src || product.images?.[0];
          if (!image) {
            card.remove();
            return;
          }
          const title = card.querySelector('strong');
          const coverHost = card.querySelector('.mb-discovery__cover');
          const cardImage = card.querySelector('img');
          cardImage.addEventListener('load', () => coverHost?.classList.add('is-loaded'), { once: true });
          cardImage.src = image;
          if (cardImage.complete) coverHost?.classList.add('is-loaded');
          if (title && product.title) {
            title.textContent = displayTitle(product.title, card.dataset.mbHeaderCreators);
            title.hidden = false;
          }
          if (product.title) card.querySelector('img').alt = `Omslag van ${product.title}`;
        } catch (_error) { card.remove(); }
      });
    };

    let searchToken = 0;
    const search = async () => {
      const query = input.value.trim();
      if (query.length < 2) {
        searchToken += 1;
        results.hidden = true;
        results.replaceChildren();
        return;
      }
      const token = ++searchToken;
      const normalizedQuery = normalize(query);
      const makerSlug = normalize(query).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      const makerEditions = [];
      if (makerSlug.length >= 4) {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const pages = await Promise.all([1, 2, 3].map((page) => fetch(`${root}search?type=product&page=${page}&q=${encodeURIComponent(query)}`, { credentials: 'same-origin' })
            .then((response) => (response.ok ? response.text() : '')).catch(() => '')));
          if (token !== searchToken) return;
          const seenEditions = new Set();
          pages.join(' ').replace(/\/products\/([a-z0-9-]+)/g, (_match, handle) => {
            if ((handle === makerSlug || handle.startsWith(`${makerSlug}-`)) && !seenEditions.has(handle)) {
              seenEditions.add(handle);
              makerEditions.push({ handle, url: `/products/${handle}`, title: '', caption: '', kind: 'loose', _mbIllustratorVersion: true, _mbSkipVersionFilter: true });
            }
            return '';
          });
        } catch (_error) { /* zoeken gaat door zonder makeredities */ }
      }
      const matchingIllustrators = Object.entries(groups.illustrators || {})
        .filter(([name]) => matchesCreatorName(String(name || '').trim(), query));
      let localProducts = [];
      if (matchingIllustrators.length) {
        const illustratorProducts = [...new Map(matchingIllustrators.flatMap(([name, items]) => (items || []).map((item) => [
          item.handle,
          {
            ...item,
            _mbCreator: String(name || '').trim(),
            _mbIllustratorVersion: true,
            /*
              Deze producten komen al uit de beheerde illustratorgroep en
              zijn daardoor de gezaghebbende resultaten. De oude aanvullende
              SKU-B-controle verwijderde geldige illustratorboekjes na het
              laden van hun afbeelding, waardoor de kaarten kort verschenen
              en daarna weer verdwenen.
            */
            _mbSkipVersionFilter: true
          }
        ]))).values()];
        localProducts = illustratorProducts;
      }
      const matchingAuthors = Object.entries(fonds || {})
        .filter(([name]) => matchesCreatorName(name, query));
      if (matchingAuthors.length) {
        matchingAuthors.forEach(([author, handles]) => {
          const authorProducts = [...new Set(handles || [])]
            .map((handle) => catalog.get(handle))
            .filter(Boolean)
            .map((product) => ({ ...product, _mbCreator: author, _mbIllustratorVersion: false, _mbSkipVersionFilter: true }));
          localProducts.push(...addExclusiveAuthorSeries(authorProducts, author));
        });
      }
      if (makerEditions.length) {
        const makerName = matchingIllustrators[0]?.[0] || matchingAuthors[0]?.[0] || query.replace(/\s+/g, ' ').trim();
        const known = new Set(localProducts.map((product) => product?.handle));
        makerEditions.forEach((edition) => { if (!known.has(edition.handle)) localProducts.push({ ...edition, _mbCreator: makerName }); });
      }
      const creatorSearch = matchingAuthors.length > 0 || matchingIllustrators.length > 0 || makerEditions.length > 0;
      if (creatorSearch) {
        let creatorResults = [...new Map(localProducts.filter((product) => product?.handle).map((product) => [product.handle, product])).values()];
        creatorResults = await mbDropAuthorDuplicates(creatorResults);
        if (token !== searchToken) return;
        render(creatorResults, query);
        return;
      }
      const matchingHandles = new Set();
      catalog.forEach((item, handle) => {
        if (normalize([item.title, item.caption, item.handle].join(' ')).includes(normalizedQuery)) matchingHandles.add(handle);
      });
      localProducts.push(...arrangeSeries([...matchingHandles].map((handle) => catalog.get(handle)).filter(Boolean)));

      try {
        const parameters = new URLSearchParams({
          q: query,
          'resources[type]': 'product',
          'resources[limit]': '10',
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': 'show',
          'resources[options][fields]': 'title,body,product_type,tag,vendor,variants.title'
        });
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}search/suggest.json?${parameters.toString()}`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Zoekresultaten konden niet worden geladen');
        const payload = await response.json();
        if (token !== searchToken) return;
        const shopifyProducts = (payload?.resources?.results?.products || []).filter((product) => !(product.tags || []).some((tag) => /^(illustrator|vormgever|alternatieve)-editie$/i.test(String(tag).trim()))).map((product) => ({
          ...(catalog.get(product.handle) || {}),
          handle: product.handle,
          title: product.title,
          url: String(product.url || `/products/${product.handle}`).split('?')[0],
          _mbSkipVersionFilter: true
        }));
        const merged = [...new Map(localProducts
          .filter((product) => product?.handle)
          .map((product) => [product.handle, product])).values()];
        const knownHandles = new Set(merged.map((product) => product.handle));
        shopifyProducts.forEach((product) => {
          if (!knownHandles.has(product.handle)) merged.push(product);
        });
        try{const _g={};JSON.parse(document.getElementById('mb-series-map-data').textContent).split(';').forEach(function(e){const p=e.trim().split('>');if(p.length===2)_g[p[0].trim()]=p[1].split(',').map(function(x){return x.trim();});});Object.keys(_g).forEach(function(s){const ord=[s].concat(_g[s]);const slots=[];merged.forEach(function(m,ix){if(ord.indexOf(m.handle)>=0)slots.push(ix);});if(slots.length<2)return;const items=slots.map(function(ix){return merged[ix];}).sort(function(a,b){return ord.indexOf(a.handle)-ord.indexOf(b.handle);});slots.forEach(function(ix,j){merged[ix]=items[j];});});}catch(_e){}
        render(merged, query);
      } catch (_error) {
        if (token !== searchToken) return;
        render([...new Map(localProducts.filter((product) => product?.handle).map((product) => [product.handle, product])).values()], query);
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => { void search(); }, 160);
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      clearTimeout(timer);
      void search();
    });
  };

  const initHomepageNavigation = (section) => {
    const chooser = section.querySelector('[data-mb40-chooser]');
    const searchPanel = section.querySelector('[data-mb40-header-search]');
    const searchToggle = section.querySelector('[data-mb40-search-toggle]');
    const searchClose = section.querySelector('[data-mb40-search-close]');

    const closeSearch = () => {
      if (!searchPanel || !searchToggle) return;
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    };
    const openSearch = () => {
      if (!searchPanel || !searchToggle) return;
      searchPanel.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      searchPanel.querySelector('[data-mb40-search-input]')?.focus();
    };
    searchToggle?.addEventListener('click', () => searchPanel?.hidden ? openSearch() : closeSearch());
    searchClose?.addEventListener('click', closeSearch);

    const scrollToChooser = () => {
      if (!chooser) return;
      const header = document.querySelector('.section-matchboox-header');
      const offset = (header?.getBoundingClientRect().height || 0) + 18;
      const top = window.scrollY + chooser.getBoundingClientRect().top - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };

    section.querySelectorAll('[data-mb40-open-chooser]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!chooser) return;
        event.preventDefault();
        const name = link.dataset.mb40OpenChooser;
        if (['all', 'collection', 'themes', 'authors', 'illustrators', 'designers'].includes(name)) {
          const homeSection = section.closest('.section-matchboox-home');
          homeSection?.classList.add('mb40--chooser-focus');
          homeSection?.classList.toggle('mb40--chooser-overview', name === 'all');
        }
        const tab = chooser.querySelector(`[data-mb-discovery-tab="${name}"]`);
        if (tab) tab.click();
        scrollToChooser();
      });
    });

    section.querySelectorAll('[data-mb40-scroll-chooser]').forEach((link) => link.addEventListener('click', (event) => {
      if (!chooser) return;
      event.preventDefault();
      scrollToChooser();
    }));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchPanel && !searchPanel.hidden) closeSearch();
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-mb40-live-search]').forEach(initLiveSearch);
    document.querySelectorAll('.section-matchboox-home .mb40').forEach(initHomepageNavigation);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Alle vaste productrijen gebruiken uitsluitend afbeelding 1 uit Shopify. */
(() => {
  const hydratePrimaryImage = async (card) => {
    if (card.dataset.mbProductPrimaryImageReady === 'true') return;
    card.dataset.mbProductPrimaryImageReady = 'true';
    const url = card.dataset.mbProductPrimaryImage;
    const host = card.querySelector('.mb40__author-image');
    if (!url || !host) return;
    try {
      const product = await fetch(`${url.replace(/\/$/, '')}.js`, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error('Product niet gevonden');
        return response.json();
      });
      const source = product.images?.[0]?.src || product.images?.[0];
      if (!source) {
        host.replaceChildren();
        return;
      }
      const image = document.createElement('img');
      image.src = source;
      image.alt = card.querySelector('strong')?.textContent?.trim() || product.title || 'MatchBoox';
      image.loading = 'lazy';
      image.decoding = 'async';
      host.replaceChildren(image);
    } catch (_error) { host.replaceChildren(); }
  };
  const boot = (scope = document) => scope.querySelectorAll('[data-mb-product-primary-image]').forEach(hydratePrimaryImage);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
